import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from "react-router-dom";
import { styled, theme } from "../../../theme";
import { Card } from "../../../card";
const Link = ({ activeStyle = { fontWeight: theme.fontWeight.bold }, disabled, ...props }) => disabled ? (_jsx(DisabledLink, { children: props.children })) : (_jsx(StyledNavLink, { activeStyle: activeStyle, ...props }));
const StyledNavLink = styled(NavLink) `
  padding: 25px 35px;
  text-decoration: none;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.color.darkBlue100} !important;
  display: inline-block;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  &:hover {
    color: ${({ theme }) => theme.color.primary} !important;
    font-weight: 600;
  }
`;
const DisabledLink = styled.span `
  padding: 25px 35px;
  text-decoration: none;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.color.darkBlue100} !important;
  display: inline-block;
  cursor: not-allowed;
  width: 100%;
  opacity: 50%;
`;
export const SideMenuItem = ({ children }) => (_jsx(StyledCard, { children: children({ Link }) }));
const StyledCard = styled(Card) `
  padding: 0;
  margin-bottom: 10px;
`;
